import axios from '../../../helpers/custom-axios';
import { notify } from '../../../helpers/notifications';
import { generate_uuidv4 } from '../../../helpers/generate-uuid';

export const globalSearchResult = async (params) => {
  return axios
    .get(`/manage/containers/global_search_result`, { params: params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const globalSearchMailers = async (params) => {
  return axios
    .get(`/manage/containers/global_search_mailers`, { params: params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const grabFieldNames = (fields, submission) => {
  let responsesPresent = submission.responses.map((r) => r.field_id);
  let fieldNames = fields
    .filter((f) => responsesPresent.includes(f.id))
    .map((f) => `${f.fieldset_name} - ${f.name}`);
  return fieldNames.join(', ');
};

export const beginGlobalExport = (containerIds, value) => {
  let params = generateGlobalParams(containerIds, value);
  const config = 'popup,left=600,top=400,width=740,height=460';
  window.open(`/manage/containers/export_result?${params}`, '_blank', config);
};

const generateGlobalParams = (containerIds, value) => {
  let uuid = generate_uuidv4();
  let params = {
    format: JSON.stringify({ container_ids: containerIds }),
    export_uuid: uuid,
    value,
  };
  let urlParams = new URLSearchParams(params).toString();
  return urlParams;
};
